import { render, staticRenderFns } from "./contentBox.vue?vue&type=template&id=9feac2b4&"
import script from "./contentBox.vue?vue&type=script&lang=js&"
export * from "./contentBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports